import styled from 'styled-components';

interface IOptionColors {
  background: string;
  backgroundSelected: string;
  border: string;
  borderSelected: string;
  inputBackground: string;
  inputBorder: string;
  inputHoverCheckboxBackground: string;
  text: string;
  textSelected: string;
}

export const StyledPlanOption = styled.li<{
  colors: IOptionColors,
  isCheckboxOrRadio: boolean,
  isSelected: boolean,
}>`
  ${({ colors, isCheckboxOrRadio, isSelected }) => (`
    background: ${isCheckboxOrRadio && isSelected ? colors.backgroundSelected : colors.background};
    border: 0.09375em solid ${isSelected ? colors.borderSelected : colors.border};
    font-family: var(--font-family);

    &:focus,
    &:focus-within {
      border-color: ${colors.borderSelected};
    }

    @media (hover: hover) {
      &:hover {
        border-color: ${colors.borderSelected};
      }
    }

    .hidden {
      appearance: none;
      margin: 0;
      pointer-events: none;
    }

    .radio {
      outline: 0;
      height: 1.0625rem;
      min-width: 1.0625rem;
      width: 1.0625rem;
      appearance: none;
      border: 0.125rem solid #000000;
      border-radius: 50%;
      cursor: pointer;
      margin: 0;
    }

    .radio:checked {
      background: ${colors.inputBackground};
      border: 0.125rem solid ${colors.inputBorder};
      box-shadow: inset 0 0 0 0.1875rem #ffffff;
    }

    &:focus .radio,
    &:focus-within .radio,
    &:hover .radio {
      border: 0.125rem solid ${colors.inputBorder};
    }

    .checkbox {
      appearance: none;
      outline: 0;
      height: 1rem;
      min-width: 1rem;
      width: 1rem;
      background: transparent;
      border: 0.125rem solid #000000;
      border-radius: 0.1875rem;
      cursor: pointer;
    }

    .checkbox:checked {
      position: relative;
      background: ${colors.inputBackground};
      border: 0.125rem solid ${colors.inputBorder};
    }

    .checkbox:checked::after {
      content: "";
      position: absolute;
      top: 0.0625rem;
      left: 0;
      height: 100%;
      width: 100%;
      background: url(
        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSA1TDQgOEwxMSAxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPjwvc3ZnPg=="
      );
      background-repeat: no-repeat;
      transform: scale(0.8);
    }

    &:focus .checkbox,
    &:focus-within .checkbox,
    &:hover .checkbox {
      background: ${colors.inputHoverCheckboxBackground};
      border: 0.125rem solid ${colors.inputBorder};

      &:checked {
        background: ${colors.inputBackground};
      }
    }
  `)}
`;
